import React from 'react';
import { X } from 'lucide-react';

export const defaultProgramForm = {
  title: '',
  slug: '',
  price: '',
  duration: '',
  about_program: '',
  about_program_title: 'О программе',
  features_title: 'Особенности программы',
  feature1: '',
  feature2: '',
  feature3: '',
  feature4: '',
  feature1_color: '#662d91',
  feature2_color: '#4897d2',
  feature3_color: '#28c4f4',
  feature4_color: '#662d91',
  benefit1: '',
  benefit2: '',
  benefit3: '',
  benefit4: '',
  details_section_title: 'Формат участия',
  details_frequency: '',
  details_duration: '',
  details_location: '',
  details_group: '',
  details_duration_label: 'Длительность',
  details_duration_hint: 'возможность продления',
  details_location_label: 'Локация',
  coach_id: '',
  coach_title: '',
  coach_bio: '',
  registration_title: 'Хотите узнать больше?',
  registration_text:
    'Оставьте заявку, и мы свяжемся с вами, чтобы рассказать больше о программе и ответить на ваши вопросы.',
  registration_button_text: 'Записаться на консультацию',
  registration_footer_text: 'Мы свяжемся с вами в ближайшее время',
  price_label: 'Стоимость',
};

export const programToForm = (program) => ({
  ...defaultProgramForm,
  ...program,
  price: program?.price ?? '',
  coach_id: program?.coach?.id || '',
});

export const formToProgramPayload = (programForm) => ({
  ...programForm,
  price: programForm.price !== '' ? Number(programForm.price) : null,
  coach_id: programForm.coach_id ? Number(programForm.coach_id) : null,
});

const ProgramAdminFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  editingProgramId,
  programForm,
  setProgramForm,
  coaches,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
          <h3 className="text-xl font-bold text-gray-900">
            {editingProgramId ? 'Редактировать программу' : 'Добавить программу'}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X size={18} />
          </button>
        </div>

        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <input className="border rounded-lg px-3 py-2 md:col-span-2" placeholder="Название *" value={programForm.title} onChange={(e) => setProgramForm((prev) => ({ ...prev, title: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Slug" value={programForm.slug || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, slug: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" type="number" min="0" placeholder="Цена" value={programForm.price} onChange={(e) => setProgramForm((prev) => ({ ...prev, price: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Длительность" value={programForm.duration || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, duration: e.target.value }))} />
            <select className="border rounded-lg px-3 py-2" value={programForm.coach_id} onChange={(e) => setProgramForm((prev) => ({ ...prev, coach_id: e.target.value }))}>
              <option value="">Тренер (не выбран)</option>
              {coaches.map((coach) => (
                <option key={coach.id} value={coach.id}>{coach.first_name} {coach.last_name}</option>
              ))}
            </select>
            <input className="border rounded-lg px-3 py-2" placeholder="Роль тренера (текст)" value={programForm.coach_title || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, coach_title: e.target.value }))} />
          </div>

          <textarea className="w-full border rounded-lg px-3 py-2" rows={3} placeholder="О программе" value={programForm.about_program || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, about_program: e.target.value }))} />
          <textarea className="w-full border rounded-lg px-3 py-2" rows={2} placeholder="Био тренера" value={programForm.coach_bio || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, coach_bio: e.target.value }))} />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Заголовок: О программе" value={programForm.about_program_title || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, about_program_title: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Заголовок: Особенности" value={programForm.features_title || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, features_title: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Особенность 1" value={programForm.feature1 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature1: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Особенность 2" value={programForm.feature2 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature2: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Особенность 3" value={programForm.feature3 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature3: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Особенность 4" value={programForm.feature4 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature4: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <input className="border rounded-lg px-3 py-2" type="color" value={programForm.feature1_color || '#662d91'} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature1_color: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" type="color" value={programForm.feature2_color || '#4897d2'} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature2_color: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" type="color" value={programForm.feature3_color || '#28c4f4'} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature3_color: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" type="color" value={programForm.feature4_color || '#662d91'} onChange={(e) => setProgramForm((prev) => ({ ...prev, feature4_color: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Преимущество 1" value={programForm.benefit1 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, benefit1: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Преимущество 2" value={programForm.benefit2 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, benefit2: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Преимущество 3" value={programForm.benefit3 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, benefit3: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Преимущество 4" value={programForm.benefit4 || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, benefit4: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Заголовок блока деталей" value={programForm.details_section_title || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_section_title: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Label цены" value={programForm.price_label || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, price_label: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Частота" value={programForm.details_frequency || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_frequency: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Длительность блока" value={programForm.details_duration || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_duration: e.target.value }))} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Локация" value={programForm.details_location || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_location: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Группа" value={programForm.details_group || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_group: e.target.value }))} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Label длительности" value={programForm.details_duration_label || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_duration_label: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Подсказка длительности" value={programForm.details_duration_hint || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_duration_hint: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Label локации" value={programForm.details_location_label || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, details_location_label: e.target.value }))} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="border rounded-lg px-3 py-2" placeholder="Заголовок регистрации" value={programForm.registration_title || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, registration_title: e.target.value }))} />
            <input className="border rounded-lg px-3 py-2" placeholder="Текст кнопки регистрации" value={programForm.registration_button_text || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, registration_button_text: e.target.value }))} />
          </div>
          <textarea className="w-full border rounded-lg px-3 py-2" rows={2} placeholder="Текст регистрации" value={programForm.registration_text || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, registration_text: e.target.value }))} />
          <input className="w-full border rounded-lg px-3 py-2" placeholder="Подпись под кнопкой" value={programForm.registration_footer_text || ''} onChange={(e) => setProgramForm((prev) => ({ ...prev, registration_footer_text: e.target.value }))} />

          <button type="submit" disabled={isSubmitting} className="w-full py-3 rounded-lg text-white bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] disabled:opacity-60">
            {isSubmitting ? 'Сохраняем...' : editingProgramId ? 'Сохранить изменения' : 'Добавить программу'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProgramAdminFormModal;
